module.exports = {
  twitch: {
    client_id: 'mfnzn7ykosbz8552ujm6lpsu0navod',
    name: 'hopnami',
    user_id: '43266220'
  },
  mixer: {
    name: 'hopnami'
  }
};
